import { render, staticRenderFns } from "./ConfirmAffiliaton.vue?vue&type=template&id=73ce889d&scoped=true&"
import script from "./ConfirmAffiliaton.vue?vue&type=script&lang=js&"
export * from "./ConfirmAffiliaton.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmAffiliaton.vue?vue&type=style&index=0&id=73ce889d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ce889d",
  null
  
)

export default component.exports